import type { FC } from 'react'
import { useDealFiltersOpsDispatch } from '../../DealFiltersProvider'
import CartButton from '../../../shopping-cart/buttons/CartButton'

const ClearAllButton: FC = () => {
  const dispatch = useDealFiltersOpsDispatch()

  return (
    <CartButton
      data-cy="shop-filter-clear-all-btn"
      color="secondary"
      className="w-1/2 h-12 text-lg font-normal lg:w-auto lg:text-base lg:h-8 lg:ml-4 lg:bg-transparent lg:text-white/80 lg:hover:text-white lg:p-1"
      onClick={() => dispatch({ type: 'reset-all-filters' })}
    >
      Clear all
    </CartButton>
  )
}

export default ClearAllButton
